import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { FormHelperText, InputLabel } from '@mui/material';


export default function AppAutoComplete(props) {
  const { label, disabled, getData, onSelect, defaultValue, optionKey = 'id' } = props;
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const [errorMessage, setErrorMessage] = React.useState('');

  const fetchData = async () => {
    setErrorMessage('');
    const resp = await getData();
    if(!resp || !resp.length) {
      setOpen(false);
      setErrorMessage('Cannot fetch data!');
    }
    setOptions(resp);
  }

  return (<>
    <InputLabel>{label}</InputLabel>
    <Autocomplete
      id="asynchronous-options"
      disabled={disabled}
      autoFocus={true}
      sx={{ color: '#f8f8f8' }}
      open={open}
      onOpen={() => {
        setOpen(true);
        fetchData();
      }}
      onClose={() => {
        setOpen(false);
        setOptions([]);
        setErrorMessage('');
      }}
      getOptionLabel={(option) => option[optionKey]}
      options={options}
      loading={loading}
      value={defaultValue}
      onChange={(e, value) => onSelect(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress sx={{ color: '#FFFFFF' }} size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
    {errorMessage &&  <FormHelperText id="component-error-text" sx={{ color: '#FF9494', fontSize: 12 }} >{errorMessage}</FormHelperText>}
  </>

  );
}